import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Browser } from '@capacitor/browser';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {RouterLinks} from '../../../shared/constants';
import {DocumentService} from '../../../shared/documentation/services/document.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {UserStore} from '../../../authentication/state/user.store';
import { StorageService } from '../../services/storage.service';

declare var jQuery: any;
declare function initSidecolToggle(): any;
declare function initPolicyResourceNav(): any;
declare function initSearch(): any;
declare function initDemoUpdate(): any;

@Component({
    selector: 'app-broker-resources',
    templateUrl: './broker-resources.component.html',
    styleUrls: ['./broker-resources.component.scss'],
    standalone: false
})
export class BrokerResourcesComponent implements OnInit, AfterViewInit {

  RouterLinks = RouterLinks;
  inProgress = environment.inProgress;
  Resource: any;
  element: any = [];
  policy: any = [];
  documents: any = [];
  classes: any = [];
  collation: any;
  items: any;
  categoryId = 1;
  ipAddress = '';
  print = false;
  user: any;
  frequency_id = 3;
  selectedItem: any;
  constructor(
    public router: Router,
    private httpClient: HttpClient,
    private userStore: UserStore,
    private globalQuestionService: GlobalQuestionService,
    private documentService: DocumentService,
    private storageService: StorageService
  ) {
    this.storageService.remove('previous-document-page', 'flow');
    this.storageService.set('previous-document-page', this.router.url, 'flow');
  }

  ngOnInit(): void {
    this.storageService.set('previous-document-page', this.router.url, 'flow');
   

    this.user = this.userStore.getValue();
    if (!this.policy || this.policy?.policy_id === 0) {
      this.router.navigate(['/login']);
    }
    this.collation = this.policy?.collation;
    this.frequency_id = this.collation.filter((col: any) => col.entry_type === 'product_selected')[0].frequency_id;
    this.categoryId = this.policy?.product_category_id;

    jQuery('.modal-backdrop').remove();
    jQuery('.page').removeClass('modal-open');
    const classes: any[] = [];
    const items: any[] = [];
    jQuery.each(this.collation, (i: any, c: any) => {
      if (c.mandatory === 0 && c.frequency_id === this.frequency_id){
        if (c.entry_type === 'class_total') {
          classes.push(c);
        }
        if (c.entry_type === 'item') {
          items.push(c);
        }
      }
    });
    classes.push({class_id: 0});
    this.classes = classes;
    this.items = items;
    initPolicyResourceNav();
    this.documentService.getDocuments(this.policy.session_id)
      .subscribe((documents: any) => {
        this.documents = documents;
      });


  }

  ngAfterViewInit(): void {
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    const el = document.getElementsByClassName('resource-item');
    const lis = document.getElementsByClassName('lis');
    jQuery.each(this.classes, (i: any, c: any) => {
      jQuery.each(el, (i_: any, c_: any) => {
        if (jQuery(c_).hasClass(c.class_id)) {
          jQuery(c_).attr('data-category', c.class_id);
        }
      });
      jQuery.each(lis, (j_: any, k_: any) => {
        if (jQuery(k_).hasClass('li-' + c.class_id)) {
          jQuery(k_).attr('data-category', c.class_id);
        }
      });
    });

    setTimeout(() => {
      initSearch();
    }, 2000);
    initDemoUpdate();
  }
  setSelectedItem(item: any): void {
    this.selectedItem = item;
 }
 getClassName(class_id: number): string {
  return this.classes.filter((c: any) => c.class_id === class_id)[0].description_1;
 }
  openDocument(doc: any, print: boolean, pdf: boolean): void {
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    if (doc.document_name === 'Policy Schedule' || doc.document_name === 'Policy Wording' || doc.document_name === 'Record of Advice')  {
      const path = doc.document_url.toLowerCase().replace('login/?returnurl=', '/');
      
      this.router.navigate([`/${path}`], {state: {doc, print, pdf}});
    } else if (doc.document_url.indexOf('http') > -1) {
      console.log(doc);
      window.open(doc.document_url);
    } else {
      this.router.navigate(['/doc-document'], {state: {doc, print, pdf}});
    }

  }

  printDoc(url, print, pdf): void {
    this.router.navigate(['/' + url], {state: {print: print, pdf: pdf, item: this.selectedItem}});
  }
  saveCoverDate(event: any): void {
    console.log(event)

  }
  changeMode(mode: string): void {
    this.storageService.set('mode', mode, 'flow');
    this.router.navigate(['/' + RouterLinks.PolicyHolders]);
  }
}
